import { baseUrl } from "../api/index";

export async function logout() {
  try {
    const token = localStorage.getItem("token");

    if (token) {
      await fetch(`${baseUrl}/logout/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    }

    localStorage.removeItem("token");
    localStorage.removeItem("nome");
    localStorage.removeItem("nivel");

    window.location.href = "/";
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
    window.location.href = "/";
  }
}
